module.exports = __webpack_public_path__ + "img/category-fishing-game.ec857317.png";